import React, { useEffect } from "react";
import { Card, Alert, Button, Container, Modal } from "react-bootstrap";
import { getUserInfo, removeUser } from "../../../services/UserService";
import { useHistory } from "react-router-dom";
import { EditUserAsAdminModal } from "../EditUserAsAdminModal";

import { formatText, formatAllowWebText, formatSuperAdminText } from "../../../components/CONSTANTS";

export const AdminUserDetails = ({ match }) => {
    const [user, setUser] = React.useState({});
    const [error, setError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");

    let timer;
    let history = useHistory();

    useEffect(() => {
        const getUser = async () => {
            setUser(await getUserInfo(match.params.id))
        }

        getUser().then(() => {
            setError(true);
            setErrorText("Användare inladdad");
        })


        timer = setTimeout(() => {
            setError(false);
        }, 5000)

        return () => clearTimeout(timer);
    }, [])

    const handleRemove = async () => {
        setLoading(true);

        try {

            await removeUser(match.params.id).then(() => {
                setError(true);
                setErrorText("Användare borttagen");

                timer = setTimeout(() => {
                    history.goBack()
                }, 500)
            })
        } catch (e) {
            setError(true);
            setErrorText("Fel uppstod vid borttagning av användare")
        }
        setLoading(false);
    }


    const handleUpdateUser = async () => {
        setLoading(true);


        setLoading(false);
    }


    return (
        <Container>

            {error ? <Alert variant={"success"}>
                {errorText}
            </Alert> : null}

            {/*
            <Button variant={"primary"} disabled={loading} onClick={() => handleUpdateUser()}>
                Uppdatera användare
            </Button>
*/}

            {/*Spara ändringar Modal
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Bekräfta ändringar</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {newFirstName != null &&
                        <Row>
                            <span>Förnamn: {newFirstName}</span>
                        </Row>
                    }
                    {newLastName != null &&
                        <Row>
                            <span>Efternamn: {newLastName}</span>
                        </Row>
                    }

                    {newAccountType != null &&
                        <Row>
                            <span>Behörighet: {newAccountType}</span>
                        </Row>

                    }

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Avbryt
                    </Button>
                    <Button variant="primary" onClick={handleUpdateUser}>
                        Spara ändringar
                    </Button>
                </Modal.Footer>
            </Modal>
*/}
            <Card>
                <Card.Header>
                    <Container>
                        Användarid: {user.uid}
                    </Container>
                </Card.Header>
                <Card.Body>
                    <Container>
                        Förnamn: {user.firstName}
                        <hr />
                        Efternamn: {user.lastName}
                        <hr />
                        E-post: {user.email}
                        <hr />
                        Användar-id: {user.uid}
                        <hr />
                        Företag: {user.company}
                        <hr />
                        Leadtubadmin?: {formatSuperAdminText(user.superadmin)}
                        <hr />
                        Rättigheter: {formatAllowWebText(user.allowWeb)}
                    </Container>
                </Card.Body>
                <Container>
                    <EditUserAsAdminModal
                        firstName={user.firstName}
                        lastName={user.lastName}
                        email={user.email}
                        userid={user.uid}
                        company={user.company}
                        allowWeb={user.allowWeb}
                        superadmin={user.superadmin}
                    />
                    <Button variant={"warning"} disabled={loading} onClick={() => handleRemove()}>
                        Ta bort användare
                    </Button>
                </Container>
            </Card>

        </Container>
    )
}
